import dayjs from "dayjs"
import LocalizedFormat from "dayjs/plugin/localizedFormat"
import React from "react"
import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { useToasts } from "react-toast-notifications"
import DashboardChecklist from "../../components/DashboardComponents/DashboardChecklist"
import DashboardHero from "../../components/DashboardComponents/DashboardHero"
import DashboardItems from "../../components/DashboardComponents/DashboardItems"
import DashboardSteps from "../../components/DashboardComponents/DashboardSteps"
import FullLoader from "../../components/Loaders/FullLoader"
import DashboardNavbar from "../../components/Navbar/DashboardNavbar"
import { useEvent } from "../../context/EventContext"
import {
  addProductToRegistry,
  deleteProductFromRegistry,
  getAllUserEvent,
  getRegistries
} from "../../utils/ApiRequests"
import { getApiErrorMessage } from "../../utils/ApiUtils"

const Dashboard = () => {
  dayjs.extend(LocalizedFormat)
  const [loading, setLoading] = useState(true)
  const [events, setEvents] = useState([])
  const [selectedEvent, setSelectedEvent] = useState(events?.length - 1)
  const [registry, setRegistry] = useState({})
  const { addToast } = useToasts()
  const [deleting, setDeleting] = useState(false)
  const { setCheckListHack } = useEvent()

  // Local storage state hack
  useEffect(() => {
    const parsedEvent = Number(localStorage.getItem("event") || 0)
    setSelectedEvent(parsedEvent)
  }, [])

  useEffect(() => {
    localStorage.setItem("event", selectedEvent)
  }, [selectedEvent])
  // End of local storage state hack \\

  // Get events
  useEffect(() => {
    getAllUserEvent()
      .then(res => {
        setEvents(res.data.data)
        // setSelectedEvent()
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
      })
  }, [events.length])
  // End of getting events

  // Destructuring Items from selected events

  const { event_owners_name, end_date, registries } =
    events[selectedEvent] || {}

  // Get Registry
  useEffect(() => {
    setLoading(true)
    if (registries) {
      getRegistries(`/${registries[0]}`)
        .then(res => {
          setRegistry(res.data.data)
          setLoading(false)
        })
        .catch(err => {
          addToast(getApiErrorMessage(err.response), {
            appearance: "error",
            autoDismiss: true
          })
          setLoading(false)
        })
    }
  }, [registries, addToast, deleting])
  // End of getting rgistries

  // Delete Product
  const DeleteProduct = id => {
    setLoading(true)
    setDeleting(true)
    deleteProductFromRegistry(registries ? registries[0] : "", id)
      .then(res => {
        setLoading(false)
        setDeleting(false)
        addToast(res.data.message, {
          appearance: "success",
          autoDismiss: true
        })
      })
      .catch(err => {
        setLoading(false)
        setDeleting(false)
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  const addItemToRegistry = data => {
    setLoading(true)
    setDeleting(true)

    addProductToRegistry(registries ? registries[0] : "", data)
      .then(res => {
        setLoading(false)
        setDeleting(false)
        addToast(res.data?.message, {
          appearance: "success",
          autoDismiss: true
        })
      })
      .catch(err => {
        setLoading(false)
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  // End of deleting products

  const handleSelectEvent = e => {
    setSelectedEvent(e.target.value)
  }

  const {
    orderProgress,
    target,
    wallet,
    products,
    minProductPrice,
    maxProductPrice,
    step1,
    step2,
    step3,
    step4,
    step5,
    categories,
    contributions
  } = registry

  return (
    <div className="global-container">
      {loading && <FullLoader />}
      <DashboardNavbar />

      <div className="flex justify-between items-center flex-wrap mt-32 mb-3">
        <select
          className=" p-2 pl-0 focus:outline-none bg-white cursor-pointer mobiles:mb-2"
          onChange={e => handleSelectEvent(e)}
          value={selectedEvent}
        >
          <option value="">Select an event</option>
          {events.map((event, i) => (
            <option key={i} value={i}>
              {event.name}
            </option>
          ))}
        </select>

        {registries?.length && (
          <Link className="flex items-center" to={`/registry/${registries[0]}`}>
            <img
              src={require("../../assets/preview.svg").default}
              alt="settings"
              className="mr-2 h-5"
            />
            <p className="text-lg text-sbg-grey">Manage registry</p>
          </Link>
        )}
      </div>

      {!!events.length && (
        <>
          <DashboardHero
            name={event_owners_name}
            date={dayjs(end_date).format("LL")}
            progressValue={
              orderProgress < 1
                ? 0
                : parseInt((orderProgress + wallet?.current_balance) / target)
            }
            cashValue={wallet?.current_balance || 0}
            giftValue={orderProgress}
            registry={registries}
          />
          <DashboardSteps
            step1={step1}
            step2={step2}
            step3={step3}
            step4={step4}
            step5={step5}
            registryId={registries}
          />
          <DashboardChecklist registry={registries} />
          <DashboardItems
            products={products || []}
            deleteProduct={DeleteProduct}
            addProduct={addItemToRegistry}
            registryId={registries}
            contributions={contributions}
          />
        </>
      )}

      {/* If events are empty create this */}
      {!events.length && !loading && (
        <div className="flex flex-col items-center">
          <h4 className="mt-24 text-center text-2xl font-medium text-grey ">
            Please create an event
          </h4>

          <Link
            to="/create-event"
            className="mt-10 py-3 px-11 bg-sbg-light-green text-transparent mx-auto rounded-lg text-base text-white  text-center"
          >
            New Event
          </Link>
        </div>
      )}
    </div>
  )
}

export default Dashboard
